import { useContext } from "react";

import { ImageOverlayContext } from "./ImageOverlayContext";
import { ImageOverlayContextValue } from "./types";

export function useImageOverlay(): ImageOverlayContextValue {
  const context = useContext(ImageOverlayContext);
  if (!context) {
    throw new Error("useImageOverlay must be used within an ImageOverlayProvider");
  }
  return context;
}
